module.exports = __webpack_public_path__ + "img/11-bn.7272eaba.png";